import type { ProgramSlideTableBlockV1 } from '../types/programContentSlideCanvas';

/** 셀 padding + 한 줄 높이(대략) — 빈 표 최소 높이 산정용 */
export const TABLE_ROW_MIN_HEIGHT_PX = 22;

function clampTableDim(n: number): number {
  if (!Number.isFinite(n)) return 0.1;
  return Math.min(1, Math.max(0.02, n));
}

function fracListClose(a: number[], b: number[], epsilon = 0.008): boolean {
  if (a.length !== b.length) return false;
  for (let i = 0; i < a.length; i += 1) {
    if (Math.abs((a[i] ?? 0) - (b[i] ?? 0)) > epsilon) return false;
  }
  return true;
}

export function measureTableRowHeightsPx(gridEl: HTMLTableElement): number[] {
  return Array.from(gridEl.querySelectorAll('tbody > tr')).map((tr) => tr.getBoundingClientRect().height);
}

export function measureTableContentHeightPx(gridEl: HTMLTableElement): number {
  return gridEl.getBoundingClientRect().height;
}

export function syncTableHeightToContent(
  table: ProgramSlideTableBlockV1,
  contentHeightPx: number,
  rowHeightsPx: number[],
  canvasHeightPx: number
): ProgramSlideTableBlockV1 | null {
  if (!Number.isFinite(canvasHeightPx) || canvasHeightPx <= 0) return null;
  if (!Number.isFinite(contentHeightPx) || contentHeightPx <= 0) return null;

  const minContentPx = Math.max(TABLE_ROW_MIN_HEIGHT_PX, table.rowCount * TABLE_ROW_MIN_HEIGHT_PX);
  const targetPx = Math.max(minContentPx, contentHeightPx);
  const maxH = Math.max(0.02, 1 - table.y);
  const nextH = Math.min(clampTableDim(targetPx / canvasHeightPx), maxH);

  const rowSum = rowHeightsPx.reduce((sum, h) => sum + (Number.isFinite(h) ? Math.max(0, h) : 0), 0);
  const nextRowFracs =
    rowSum > 0 && rowHeightsPx.length === table.rowCount
      ? rowHeightsPx.map((h) => Math.max(0, h) / rowSum)
      : [...table.rowHeightsFrac];

  const hChanged = Math.abs(nextH - table.h) > 0.001;
  const fracChanged = !fracListClose(nextRowFracs, table.rowHeightsFrac);
  if (!hChanged && !fracChanged) return null;

  return {
    ...table,
    h: nextH,
    rowHeightsFrac: nextRowFracs,
  };
}
